import { FC, PropsWithChildren } from 'react';
import { BaseCallout } from './base-callout';

type BulkCollectionTabCalloutProps = {
  anchorRef: React.RefObject<HTMLElement>;
  innerRef?: React.Ref<HTMLDivElement>;
  onDismiss?: () => void;
  showBanner: boolean;
};

export const BulkCollectionTabCallout: FC<PropsWithChildren<BulkCollectionTabCalloutProps>> = (props) => {
  return <BaseCallout {...props} placement='bottom' arrowPosition='top' />;
};
